import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import superAdminService from '../services/superAdminService';

const SuperAdminSurveys = () => {
  const navigate = useNavigate();
  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const data = await superAdminService.getAllSurveys();
        setSurveys(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Failed to load surveys", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSurveys();
  }, []);

  if (loading) return <CircularProgress sx={{ m: 5 }} />;

  return (
    <Box sx={{ p: 3 }}>
      <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/super-admin/dashboard')} sx={{ mb: 3 }}>
        Back to Dashboard
      </Button>
      
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
        All System Surveys
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ bgcolor: '#f5f5f5' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Survey Title</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Dealer</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Responses</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {surveys.map((survey) => (
              <TableRow key={survey.id || survey.Id} hover>
                <TableCell>
                    {new Date(survey.createdAt || survey.CreatedAt).toLocaleDateString()}
                </TableCell>
                
                {/* FIX: Use .title or .Title based on your controller */}
                <TableCell sx={{ fontWeight: 'bold' }}>
                    {survey.title || survey.Title || 'Untitled'}
                </TableCell>
                
                <TableCell>
                    {/* FIX: Access nested dealer name safely */}
                    {survey.dealer?.name || survey.Dealer?.Name || 'Unknown'}
                </TableCell>
                
                <TableCell>
                    {(survey.responseCount || survey.ResponseCount) > 0 ? (
                        <Chip label={`${survey.responseCount || survey.ResponseCount} Responses`} color="success" size="small" />
                    ) : (
                        <Chip label="Pending" size="small" variant="outlined" />
                    )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SuperAdminSurveys;